<template>
    <b-navbar toggleable="lg" type="dark" variant="info" class="bg-transparent">
        <b-navbar-brand href="#">IIL</b-navbar-brand>
        <b-navbar-toggle target="tsnavbar"></b-navbar-toggle>

        <b-collapse is-nav id="tsnavbar">
            <b-navbar-nav class="mr-auto">
                <b-nav-item v-if="user.loggedIn" to="/events">{{ $t('navigation.events') }}</b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <b-nav-text v-if="user.loggedIn" class="mr-3">{{ user.username }}</b-nav-text>
                <b-nav-item-dropdown right>
                    <template slot="button-content">
                        <flag :iso="locale" />
                    </template>
                    <b-dropdown-item href="#" v-on:click="changeLocale('en')"><flag iso="us" /></b-dropdown-item>
                    <b-dropdown-item href="#" v-on:click="changeLocale('de')"><flag iso="de" /></b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-form>
                    <router-link v-if="!user.loggedIn" class="btn btn-dark my-2 my-sm-0" to="/login">{{ $t('login.login') }}</router-link>
                    <a v-else class="btn btn-dark my-2 my-sm-0" href="#" v-on:click="logout">{{ $t('navigation.logout') }}</a>
                </b-nav-form>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import { Settings } from 'luxon';

export default {
    name: 'login',
    computed: {
        user() {
            return this.$store.state.user;
        },
        locale() {
            if (this.$i18n.locale === 'en') return 'us';
            return this.$i18n.locale;
        },
    },
    methods: {
        changeLocale(lang) {
            Settings.defaultLocale = lang;
            localStorage.setItem('locale', lang);
            this.$i18n.locale = lang;
            this.$root.$emit('changelocale', lang);
        },
        logout: function (e) {
            e.preventDefault();
            this.$http.post('/api/user/logout').then(() => {
                this.user.loggedIn = false;
                this.$router.push('/');
            });
        },
    },
};
</script>

<style lang="scss">
    nav .navbar-toggler {
        z-index: 1000;
    }

    #tsnavbar {
        @media (max-width: 991px) {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 100;
            background-color: rgba(3, 42, 56, 0.9);
            padding: 70px 30px 20px 30px;
            min-width: 220px;
        }

        &.collapsing {
            -webkit-transition: none;
            transition: none;
            display: none;
        }

        .dropdown-menu {
            min-width: 0;
        }
    }
</style>